import Team from '../../models/Team'
import Project from "../../models/Project";
import {BiddingWizard} from "./BiddingWizard";
import Page from "../Page";
import BiddingTalentStep from "./BiddingTalentStep";

export default class BiddingWizardStep extends Page
{
    static slug;
    static StepTitle;
    static StepName;
    static StepHeader;

    static PerPage = 9;

    static PageRequests = () => {
        return [
            Team.FetchAllMatchingProjectRequest,
            Project.SyncRequest
        ]
    }

    static stepTitleFor(project)
    {
    	return this.StepTitle || this.stepNameFor(project);
    }
    static stepNameFor(project)
    {
        return this.StepName || this.stepTitleFor(project);
    }
    static stepHeaderFor(project)
    {
        return this.StepHeader || this.stepTitleFor(project);
    }
    static pathFor(project)
    {
    	return BiddingWizard.pathFor(project, this.slug);
    }

    talentType()
    {
    	return this.props.project.talentMatchType();
    }

    /*
    |--------------------------------------------------------------------------
    | Fetching potential team matches for project
    |--------------------------------------------------------------------------
    */


	shouldCaptureRequests() {
	    return false
    }

	// async fetchPotentialTeamsForProject(forceRefresh = false)
	// {
	// 	let project = {...this.props.project};
    //
	// 	await this.promisedState({
	// 		potentialTalent: undefined,
	// 		isLoading: true,
	// 		error: null,
	// 	});
    //
	// 	// show loading feedback
	// 	let potentialTalent = await Team.fetchMatchingProject(
	// 	    project,
    //         this.shouldCaptureRequests(),
    //         forceRefresh
    //     );
	// 	if (!potentialTalent) {
	// 		return this.handleErrorResponse(
	// 			Team.FetchAllMatchingProjectRequest, 'error_index_project_teams'
	// 		);
	// 	}
	// 	// console.log('potentialTalent');
	// 	// console.log(potentialTalent);
    //
	// 	let fullTeams = TB.filter(potentialTalent, team => {
	// 		let estimate = team.estimateWithServiceFeeFor(
	// 			Project.make(project)
	// 		);
    //
	// 		return TB.isDefined(estimate) && estimate > 1;
	// 	});
	// 	// console.log('fullTeams');
	// 	// console.log(fullTeams);
    //
    //
	// 	await this.promisedState({
	// 		potentialTalent: fullTeams,
	// 	});
    //
	// 	// console.log('project hourly totals', this.props.project.disciplineHourlyTotals());
	// 	// console.log('potentialTeams', potentialTeams);
    //
	// 	this.promisedState({
	// 		isLoading: false,
	// 	});
	// }

    async postUpdateProject(model)
    {
        await this.promisedState({isDisabled: true});

        await this.props.toggleUsability(false);


        if (TB.isFunction(this.props.updateProject)) {
            let updatedProject = await this.props.updateProject(model);

            // console.log('updated project w/ remote changes');
        }else {
            let updatedProject = await this.props.project.update({...model});

            if (!updatedProject) {
                // handle error
                Project.SyncRequest.didHandleError = await Project.SyncRequest.handleError();
                if (Project.SyncRequest.didHandleError
                    && Project.SyncRequest.shouldRerun) {
                    return this.postUpdateProject(
                        model
                    );
                }

                await this.props.toggleUsability(true);
                await this.promisedState({isDisabled: false});

                return false;
            }
        }

        await this.props.toggleUsability(true);


        await this.promisedState({isDisabled: false});
        return true;
    }


    async refreshTalentFor(updatedTalent)
	{
		if (!updatedTalent) {
			return;
		}
        //
		// let potentialTalent = TB.map([...this.state.potentialTalent], talent => {
		//     if(talent.id === updatedTalent.id) {
		//         return updatedTalent;
        //     }
        //     return talent;
        // });

		return this.promisedState({
            isLoading: false
		});
	}

	goToTalentMatching(position) {
        this.props.goToStep(BiddingTalentStep, position ? `?fill=${position?.id}` : '');
    }

	async confirmDeletePosition(position)
	{
		let updatedProject = await this.props.project.confirmDeletePosition(
            position
        );

        if (!updatedProject) {
            return;
        }

		this.props.toggleUsability(false);

        this.props.updateProject(updatedProject);

        this.props.toggleUsability(true);
	}


	renderStepHeader() {
        return null;
	    // return (
        //     <div className="project-bidding-step-header">
        //         <h3>
        //             <small>
        //                 {this.constructor.stepTitleFor(this.props.project)}
        //             </small>
        //             {this.constructor.stepHeaderFor(this.props.project)}
        //         </h3>
        //     </div>
        // )
    }

}